module.exports = __webpack_public_path__ + "static/media/Mask Group 32.31c8a97b.png";